var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "event-brochure-stack is-ancestor" }, [
    _c(
      "div",
      { staticClass: "brochure-contents tile is-parent" },
      [
        _vm._l(_vm.visibleItems, function (item, index) {
          return _c(
            "event-card",
            {
              key: index,
              staticClass: "is-dark",
              attrs: {
                role: "article",
                item: item,
                "image-as-background": true,
                header: false,
                social: false,
              },
            },
            [
              _c("div", { staticClass: "multimedia-title event-title" }, [
                _c("div", { staticClass: "event-period" }, [
                  _vm._v(_vm._s(_vm.getEventPeriodString(item))),
                ]),
                item.EventClass
                  ? _c(
                      "div",
                      {
                        staticClass: "event-class-title-icon",
                        style: _vm.getEventClassStyle(item.EventClass),
                        attrs: {
                          title: _vm.$t(`events.eventClass.${item.EventClass}`),
                        },
                      },
                      [
                        _c(_vm.getEventClassIcon(item.EventClass), {
                          tag: "component",
                          attrs: { title: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "event-info" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: _vm.getRoute(item, null, "Event") } },
                    [
                      _c("h4", [_vm._v(_vm._s(item.Name))]),
                      _c("p", {
                        staticClass: "ingress-text",
                        domProps: { innerHTML: _vm._s(item.IngressText) },
                      }),
                      _c("button", { staticClass: "btn" }, [
                        _vm._v(_vm._s(_vm.$t("collections.explore"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        !_vm.allVisible
          ? _c("plus-more", { on: { click: _vm.onShowAll } })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }